import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Colors from "styles/colors";
const BulletCheckedIcon = ({ color, checkColor })=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "10",
                cy: "10",
                r: "10",
                fill: Colors[color] || "#CAF4E2",
                className: "circle"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "mark",
                d: "M6.27162 9.83382C5.98072 9.54874 5.50908 9.54874 5.21818 9.83382C4.92727 10.1189 4.92727 10.5811 5.21818 10.8662L8.19777 13.7862C8.48867 14.0713 8.96031 14.0713 9.25121 13.7862L15.2104 7.9462C15.5013 7.66112 15.5013 7.19891 15.2104 6.91382C14.9195 6.62874 14.4479 6.62874 14.1569 6.91382L8.72449 12.2376L6.27162 9.83382Z",
                fill: Colors[checkColor] || "#037F4C"
            })
        ]
    });
export default BulletCheckedIcon;
